import { ProjectTemplateApi } from 'api/ProjectTemplateApi';
import { backendApiClient } from 'container/backendApiClient';

export const projectTemplateApi: ProjectTemplateApi = new ProjectTemplateApi(backendApiClient);
